<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'Lexique'
});
</script>
<template>
  <ka-container
    code="lexique"
    :data="page.$info.lexique">
    <!-- Container de page -->
    <ka-container code="container-de-page">
      <PageFixeEntete
        instance-class="page-fixe-entete--p70"
        h-1="Lexique de la formation professionnelle"
        text-1="Retrouvez ici le lexique Matchers 😎<br> <br>Vous y découvrirez tous les termes que nous utilisons régulièrement pour mieux vous y retrouver, voire devenir incollable sur l’univers de la formation professionnelle !<br> "
        image="https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHwxMXx8cGVvcGxlJTIwc3R1ZHlpbmd8ZW58MHx8fHwxNjkzMzk4MDUwfDA&ixlib=rb-4.0.3&q=80&w=1080" />
      <ka-list
        code="list"
        :options="{
          placeholder: t('lexique.containerDePage.list.placeholder', `No items`),
          debounce: 0,
          entity: `Kapix.Entity.IPreviewLexique`,
          items: page.$data.previewLexicon
        }"
        :data="page.$info.list">
        <template #item="listItemProps">
          <EntitiesPreviewLexiqueLexique
            :preview-lexique="listItemProps.item"
            :options="listItemProps.options" />
        </template>
      </ka-list>
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { lexique } from './store'
import EntitiesPreviewLexiqueLexique from '~/components/Entities/PreviewLexique/Lexique/index.vue'
import PageFixeEntete from '~/components/PageFixeEntete/index.vue'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p70')
const appData = appDataStore()
const page = lexique()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
